var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBellOffOutlineMute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5825 16.0954L1.79252 1.29785L0.83252 2.25035L4.37252 5.79035C3.96699 6.54711 3.75325 7.39179 3.75002 8.25035V12.7504L2.25002 14.2504V15.0004H13.5825L15.63 17.0479L16.5825 16.0954ZM5.25002 13.5004V8.25035C5.25002 7.79285 5.33252 7.34285 5.50502 6.92285L12.0825 13.5004H5.25002ZM7.50002 15.7504H10.5C10.5 16.1482 10.342 16.5297 10.0607 16.811C9.77938 17.0923 9.39784 17.2504 9.00002 17.2504C8.6022 17.2504 8.22066 17.0923 7.93936 16.811C7.65806 16.5297 7.50002 16.1482 7.50002 15.7504ZM6.21752 3.81785C6.61502 3.56285 7.05002 3.37535 7.50002 3.21785V3.00035C7.50002 2.60253 7.65806 2.221 7.93936 1.93969C8.22066 1.65839 8.6022 1.50035 9.00002 1.50035C9.39784 1.50035 9.77938 1.65839 10.0607 1.93969C10.342 2.221 10.5 2.60253 10.5 3.00035V3.21785C12.7275 3.87785 14.25 5.92535 14.25 8.25035V11.8504L12.75 10.3504V8.25035C12.75 7.25579 12.3549 6.30196 11.6517 5.5987C10.9484 4.89544 9.99458 4.50035 9.00002 4.50035C8.41502 4.50035 7.83752 4.65035 7.32002 4.92035L6.21752 3.81785Z",
    fill: "#FA8C16"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellOffOutlineMute);
export default __webpack_public_path__ + "static/media/bell-off-outline-mute.2d7a18df.svg";
export { ForwardRef as ReactComponent };